import { render, staticRenderFns } from "./addNotice.vue?vue&type=template&id=079e630c&scoped=true"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"
import style0 from "./addNotice.vue?vue&type=style&index=0&id=079e630c&prod&lang=scss&scoped=true"
import style1 from "./addNotice.vue?vue&type=style&index=1&id=079e630c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e630c",
  null
  
)

export default component.exports